import React from 'react';
import { AiFillCheckCircle } from 'react-icons/ai';

interface IOptionCardProps {
  titulo: string;
  descricao?: string;
  selecionado: boolean;
  onClick: () => void;
}

export default function OptionCard({ titulo, descricao, selecionado, onClick }: IOptionCardProps) {
  return (
    <button
      type='button'
      role='radio'
      aria-checked={selecionado}
      onClick={onClick}
      className={[
        'relative w-full min-h-[56px] rounded-xl border px-4 py-3 text-left transition-all',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900 focus-visible:ring-offset-2',
        selecionado
          ? 'border-zinc-900 bg-zinc-900 text-white shadow-card'
          : 'border-zinc-200 bg-white text-zinc-900 hover:border-zinc-400 hover:bg-zinc-50',
      ].join(' ')}
    >
      <span className='block pr-6 font-semibold leading-snug'>{titulo}</span>
      {/* {descricao && (
        <span className={`mt-0.5 block text-sm line-clamp-2 ${selecionado ? 'text-zinc-300' : 'text-zinc-500'}`}>
          {descricao}
        </span>
      )} */}
      {selecionado && (
        <AiFillCheckCircle className='absolute right-3 top-3 h-5 w-5 text-white' aria-hidden='true' />
      )}
    </button>
  );
}
